import { render, staticRenderFns } from "./countLoanDataWithDate.vue?vue&type=template&id=2524c24a&scoped=true&"
import script from "./countLoanDataWithDate.vue?vue&type=script&lang=js&"
export * from "./countLoanDataWithDate.vue?vue&type=script&lang=js&"
import style0 from "./countLoanDataWithDate.vue?vue&type=style&index=0&id=2524c24a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2524c24a",
  null
  
)

export default component.exports